import { createGlobalStyle } from 'styled-components';
import { Theme } from '../interfaces/styled';

export interface GlobalStylesProps {
  theme: Theme;
}

const GlobalStyles = createGlobalStyle<GlobalStylesProps>`
  html {
    scroll-behavior: smooth;
  }
  
  body {
    font-family: ${({ theme }) => theme.family};
    color: ${({ theme }) => theme.colors.text};
    background: ${({ theme }) => theme.colors.bg};
    font-weight: 400;
    line-height: 1.1;
    margin: 0;
  }
`;

export { GlobalStyles };
